import apiClient from '../../../services/api-client'
import type { ReviewRequest } from '../../tenant-requests/types/tenant-request.types'
import type {
  TerminationRequest,
  SubmitTerminationRequestRequest,
  TerminationRequestListResponse,
  TerminationRequestStatus
} from '../types/termination-request.types'

/**
 * Submit a new workspace termination request (Finance / SysAdmin only)
 */
export async function submitTerminationRequest(request: SubmitTerminationRequestRequest): Promise<{ id: string }> {
  const response = await apiClient.post<{ id: string }>('/termination-request', request)
  return response.data
}

/**
 * Update a pending termination request (Requester or Approver)
 */
export async function updateTerminationRequest(id: string, request: SubmitTerminationRequestRequest): Promise<void> {
  await apiClient.put(`/termination-request/${id}`, request)
}

/**
 * Get all termination requests (SysAdmin or Workspace Admin/Approver)
 */
export async function getAllTerminationRequests(status?: TerminationRequestStatus): Promise<TerminationRequest[]> {
  const response = await apiClient.get<TerminationRequestListResponse>('/termination-request', {
    params: status ? { status } : undefined
  })
  return response.data.data
}

/**
 * Get termination requests submitted by the current user
 */
export async function getMyTerminationRequests(): Promise<TerminationRequest[]> {
  const response = await apiClient.get<TerminationRequestListResponse>('/termination-request/my-requests')
  return response.data.data
}

/**
 * Get a specific termination request by ID
 */
export async function getTerminationRequestById(id: string): Promise<TerminationRequest> {
  const response = await apiClient.get<TerminationRequest>(`/termination-request/${id}`)
  return response.data
}

/**
 * Approve a termination request (Workspace Approver or SysAdmin)
 */
export async function approveTerminationRequest(id: string, review: ReviewRequest): Promise<void> {
  await apiClient.post(`/termination-request/${id}/approve`, review)
}

/**
 * Reject a termination request (Workspace Approver or SysAdmin)
 */
export async function rejectTerminationRequest(id: string, review: ReviewRequest): Promise<void> {
  await apiClient.post(`/termination-request/${id}/reject`, review)
}
